export type SurveyAssignmentStatusInput = {
  status?: string | null;
  invitationExpiresAt?: string | null;
  completedForms?: number | null;
  inprogressForms?: number | null;
};

export type SurveyAssignmentDisplayStatus =
  | "completed"
  | "cancelled"
  | "scheduled"
  | "expired"
  | "inprogress"
  | "sent"
  | "created";

const displayMeta: Record<
  SurveyAssignmentDisplayStatus,
  { label: string; color: string; bgColor: string }
> = {
  completed: {
    label: "Completed",
    color: "#0E9F6E",
    bgColor: "#DEF7EC",
  },
  cancelled: {
    label: "Cancelled",
    color: "#9B1C1C",
    bgColor: "#FDE8E8",
  },
  scheduled: {
    label: "Scheduled",
    color: "#1E429F",
    bgColor: "#E1EFFE",
  },
  expired: {
    label: "Expired",
    color: "#9B1C1C",
    bgColor: "#FDE8E8",
  },
  inprogress: {
    label: "In Progress",
    color: "#723B13",
    bgColor: "#FDF6B2",
  },
  sent: {
    label: "Sent",
    color: "#111928",
    bgColor: "#F3F4F6",
  },
  created: {
    label: "Created",
    color: "#111928",
    bgColor: "#F3F4F6",
  },
};

export const getSurveyAssignmentDisplayStatus = (
  input: SurveyAssignmentStatusInput
): SurveyAssignmentDisplayStatus => {
  const status = input.status || "";
  if (status === "completed") return "completed";
  if (status === "cancelled") return "cancelled";
  if (status === "scheduled") return "scheduled";
  if (status === "created") return "created";

  if (
    status !== "completed" &&
    input.invitationExpiresAt &&
    new Date(input.invitationExpiresAt).getTime() < Date.now()
  ) {
    return "expired";
  }

  if (
    status === "sent" &&
    ((input.inprogressForms ?? 0) > 0 || (input.completedForms ?? 0) > 0)
  ) {
    return "inprogress";
  }

  if (status === "sent") return "sent";

  return "sent";
};

export const getSurveyAssignmentStatusMeta = (
  input: SurveyAssignmentStatusInput
) => {
  const key = getSurveyAssignmentDisplayStatus(input);
  return { key, ...displayMeta[key] };
};
